:root {
  font-family: "Segoe UI Variable", "Segoe UI", Arial, sans-serif;
  color: #17151f;
  background: #f7f7fb;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  --ink: #17151f;
  --muted: #676273;
  --line: #dedbe7;
  --canvas: #f7f7fb;
  --surface: #ffffff;
  --surface-soft: #eef0ff;
  --accent: #6b3df5;
  --accent-deep: #4d28d8;
  --accent-soft: #ece8ff;
  --cyan: #15c7d4;
  --coral: #ff6b5f;
  --yellow: #f4e54b;
  --shadow: 0 24px 70px rgba(67, 49, 126, 0.14);
  --shadow-sm: 0 12px 34px rgba(41, 34, 72, 0.1);
  --container: 1240px;
  --page-gutter: 48px;
  --section-space: 104px;
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-7: 28px;
  --space-8: 32px;
  --space-9: 36px;
  --space-10: 40px;
  --space-12: 48px;
  --space-14: 56px;
  --space-16: 64px;
  --space-20: 80px;
  --radius-xs: 7px;
  --radius-sm: 12px;
  --radius-md: 16px;
  --radius-lg: 20px;
  --radius-xl: 26px;
  --radius-pill: 999px;
  --font-brand: 29px;
  --font-h1: clamp(50px, 5vw, 68px);
  --font-h1-feature: clamp(48px, 4.5vw, 64px);
  --line-h1: 1;
  --font-h2: clamp(40px, 4vw, 54px);
  --line-h2: 1.04;
  --font-h3: 32px;
  --line-h3: 1.16;
  --font-h4: 24px;
  --line-h4: 1.25;
  --font-body-lg: 19px;
  --line-body-lg: 1.58;
  --font-body: 16px;
  --line-body: 1.55;
  --font-body-sm: 14px;
  --line-body-sm: 1.5;
  --font-nav: 15px;
  --line-nav: 1.5;
  --font-button: 16px;
  --line-button: 1.25;
  --font-button-small: 14px;
  --font-badge: 13px;
  --line-badge: 1.4;
}

* { box-sizing: border-box; }
html { overflow-x: clip; scroll-behavior: smooth; }
body { margin: 0; min-width: 320px; overflow-x: clip; background: var(--canvas); }
.metrika-pixel { position: absolute; left: -9999px; width: 1px; height: 1px; }
a { color: inherit; text-decoration: none; }
button, input { font: inherit; }
img { display: block; max-width: 100%; }
h1, h2, h3, p { margin-top: 0; }
button, a { -webkit-tap-highlight-color: transparent; }
:focus-visible { outline: 3px solid var(--cyan); outline-offset: 3px; }
::selection { color: #fff; background: var(--accent); }

@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior: auto; }
  *, *::before, *::after { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
}
